import { deprecated } from 'typesafe-actions';
import { ForgotPasswordModel, ResetPasswordModel } from "./ResetPasswordModels";

const { createStandardAction } = deprecated;

export const forgotPassword = createStandardAction('resetPassword/FORGOT_PASSWORD')<ForgotPasswordModel>();
export const resetPassword = createStandardAction('resetPassword/RESET_PASSWORD')<ResetPasswordModel>();